import {
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import ContributorSelectTable from './ContributorSelectTable';
import { ISelect, TeamMenu } from '@devd-client/devd/components';

interface ContributorSelectTableModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectContributors: (contributors: string[]) => void;
  initialSelectedContributors?: string[];
}

export const ContributorSelectTableModal = ({
  isOpen,
  onClose,
  onSelectContributors,
  initialSelectedContributors,
}: ContributorSelectTableModalProps) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedContributors, setSelectedContributors] = useState<string[]>(
    initialSelectedContributors || []
  );
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState<ISelect>({
    label: 'Organization',
    value: '',
  });

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleContributorSelection = (contributors: string[]) => {
    setSelectedContributors(contributors);
  };

  const handleSubmit = () => {
    onSelectContributors(selectedContributors);
    onClose();
  };

  const handleSelectedTeam = (team: ISelect) => {
    setSelectedTeam(team);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent maxH="600px" maxW="800px">
        <ModalHeader>Select Contributors</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={'-10px'} mt={'-16px'}>
          <Flex mb={4} align={'end'} gap={2}>
            <InputGroup size="sm" maxW="240px">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
              </InputLeftElement>
              <Input
                placeholder="Search contributors"
                value={searchTerm}
                onChange={handleSearch}
              />
            </InputGroup>
            <TeamMenu
              selectedTeam={selectedTeam}
              handleSelectedTeam={handleSelectedTeam}
              hideShowDetails
            />
            <Button
              variant="custom-outline"
              size="sm"
              onClick={() => setShowSelectedOnly(!showSelectedOnly)}
              minW="124px"
              ml="auto"
            >
              {showSelectedOnly ? 'Show All' : 'Show Selected'}
            </Button>
          </Flex>

          <ContributorSelectTable
            onSelectContributors={handleContributorSelection}
            searchTerm={searchTerm}
            teamId={selectedTeam.value}
            initialSelectedContributors={initialSelectedContributors}
            showSelectedOnly={showSelectedOnly}
          />
        </ModalBody>

        <ModalFooter>
          <Flex w="100%" justify="space-between" align="center">
            <Text color="text.secondary2" fontSize="sm">
              {selectedContributors.length} contributors selected
            </Text>
            <Button
              variant="filled"
              onClick={handleSubmit}
              isDisabled={selectedContributors.length === 0}
            >
              Add Contributors
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
